import UseScreenSize from '@/hooks/UseScreenSize';
import classNames from './ListenPreparation.module.scss';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import commonUtils from '@/utils/common';
import { NewGameTypes, VocabularyPreparationProps } from '@/types/game';
import { quizDescriptionPart2 } from './helper';

import TheButton from '@/components/TheButton/TheButton';
import GoBackBtn from '@/components/GoBackBtn/GoBackBtn';
import { useAppSelector } from '@/store';
import { gameSelector } from '@/store/reducers/game';
import { unitSelector } from '@/store/reducers/unit';
import { GameDetailsBlock } from './components/GameDetailsBlock';
import { authSelector } from '@/store/reducers/auth';

const ListenPreparation = ({
  selectedQuiz,
  selectedTopic,
  emitOnStartQuiz,
  emitGoBack,
  emitOnPractice,
}: VocabularyPreparationProps) => {
  const { t } = useTranslation();
  const { isMobile } = UseScreenSize();
  const { gameQuestions, gameType } = useAppSelector(gameSelector);
  const { selectedUnit } = useAppSelector(unitSelector);
  const { nativeLanguage } = useAppSelector(authSelector);

  const TEMP_GAMETYPE = gameQuestions[0].gameType as any;

  const skillImageBlock = (
    <SVG
      className={classNames.skillImage}
      src={commonUtils.activityImage(gameType, selectedUnit?.order || 1)}
    />
  );

  const content = isMobile ? (
    <>
      <GameDetailsBlock
        selectedTopic={selectedTopic}
        selectedQuiz={selectedQuiz}
        isPreparationScreen={true}
      />
      {skillImageBlock}
      <div style={{ width: '100%' }}>
        <p
          className={classNames.quizDescription}
          dangerouslySetInnerHTML={{ __html: t(quizDescriptionPart2(gameType)).toString() }}
        />
        <div className={classNames.bottom}>
          <TheButton
            className={classNames.button}
            text={t('letsGo')}
            emitOnClick={emitOnStartQuiz}
            shouldRecolor
          />
          {TEMP_GAMETYPE === NewGameTypes.Vocabulary && (
            <TheButton
              className={classNames.button}
              text={t('practice')}
              plain
              emitOnClick={emitOnPractice}
            />
          )}
        </div>
      </div>
    </>
  ) : (
    <>
      <div className={classNames.warrper}>
        {skillImageBlock}
        <GameDetailsBlock
          selectedTopic={selectedTopic}
          selectedQuiz={selectedQuiz}
          isPreparationScreen={true}
        />
      </div>
      <div className={classNames.bottom}>
        <TheButton
          className={classNames.button}
          text={
            TEMP_GAMETYPE === NewGameTypes.Vocabulary && nativeLanguage !== 'en'
              ? t('practice')
              : t('illDoItLater')
          }
          plain
          emitOnClick={
            TEMP_GAMETYPE === NewGameTypes.Vocabulary && nativeLanguage !== 'en'
              ? emitOnPractice
              : emitGoBack
          }
        />
        <TheButton
          className={classNames.button}
          text={t('letsGo')}
          emitOnClick={emitOnStartQuiz}
          shouldRecolor
        />
      </div>
    </>
  );

  return (
    <div className={classNames.listenPreparation}>
      {isMobile && (
        <div className={classNames.top}>
          <GoBackBtn
            className={classNames.goBackBtn}
            showText={false}
            emitClick={() => emitGoBack?.()}
          />
        </div>
      )}
      {content}
    </div>
  );
};

export default ListenPreparation;
